import { FC } from 'react';
import { CheckCircle } from '@eqi-investimentos/icons/web';
import { Button, Flex, Text } from '@eqi-investimentos/react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

export const ModalConfirmedEvent: FC<ModalConfirmedEventProps> = ({
  t,
  isOpen,
  onClose,
}) => {
  if (!isOpen) return <></>;

  return (
    <Modal onClose={onClose} isOpen={isOpen} isCentered>
      <ModalOverlay />
      <ModalContent w="23.4375rem" minH="23.25rem">
        <ModalCloseButton top="2rem" right="2rem" />
        <ModalBody w="full" transition="all 0.5s ease">
          <Flex
            w="full"
            minH="23rem"
            flexDir="column"
            alignItems="start"
            justifyContent="center"
            gap="2xl"
            p="l"
            pt="6xl"
          >
            <CheckCircle
              width="4.25rem"
              height="4.25rem"
              color="content.brand"
            />
            <Text
              textAlign="start"
              size="h6"
              fontWeight="normal"
              color="content.primary"
            >
              {t('screens.events.confirmPresence.title')}
            </Text>
            <Text
              textAlign="start"
              size="xl"
              fontWeight="normal"
              color="content.secondary"
            >
              {t('screens.events.confirmPresence.description')}
            </Text>

            <Button
              aria-label="button-modal-presence-confirmed"
              variant="solid"
              w="full"
              h="3rem"
              justifyContent="center"
              onClick={onClose}
            >
              {t('screens.events.confirmPresence.button')}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

interface ModalConfirmedEventProps {
  t: (key: string) => string;
  isOpen: boolean;
  onClose: () => void;
}
